import React from 'react';
import { useTranslation } from 'react-i18next';
import {Trans} from 'react-i18next';
import Icon from '../../../../../../../../../../../../../../components/icon/index';
import './index.css';

const LockedSharingReason = (props) => {
	const { t } = useTranslation();
	if(props.type === 'expired_licenses'){
		return (
			<div className="p-4 locked-sharing-reason d-flex align-items-center justify-content-center">
				<Icon name="lock" className="text-danger m-0 mr-3"/>				
				<Trans i18nKey="textExpiredContent2"/>
				<a role="button" className="ml-3" href={'/api/payment/new'} target="_blank" rel="noreferrer">{t("textBuy")}</a>
			</div>

		)
	} else {
		return null;
	}

};

export default LockedSharingReason;